import { computed, ref, watch } from 'vue';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { storeToRefs } from 'pinia';

export function useVerifyEmail() {
	const userStore = useUserStore();
	const { loadInfo } = userStore;
	const { userInfo, isLoggedIn, isAccountVerified } = storeToRefs(userStore);

	const showBanner = ref(false);

	const userCreationTime = computed(() => userInfo.value.creationTime);

	watch(
		isLoggedIn,
		async () => {
			await loadInfo();

			if (!isLoggedIn.value || userInfo.value.emailVerified) {
				showBanner.value = false;
			}

			if (isLoggedIn.value && !isAccountVerified.value && !showBanner.value) {
				showBanner.value = true;
			}
		},
		{ immediate: true }
	);

	return {
		showBanner,
		userCreationTime,
	};
}
